<template>
    <div>
        <div ref="map"></div>
    </div>
</template>

<script>
export default {
    props: {
        airport: String,
    },
    data() {
        return {
            ready: false,
            map: null,
            airportData: {},
        };
    },
    mounted() {
        this.airportData = JSON.parse(this.airport);
        this.map = L.map(this.$refs.map, {
            scrollWheelZoom: false,
            dragging: !L.Browser.mobile,
            tap: !L.Browser.mobile,
        });
        L.tileLayer(this.$root.mapConfig.url, {
            maxZoom: 13,
            attribution: this.$root.mapConfig.attribution,
        }).addTo(this.map);
        L.marker(this.airportData.latitudeLongitude.coordinates, {
            icon: this.$root.mapConfig.icon,
        }).addTo(this.map);
        this.map.setView(this.airportData.latitudeLongitude.coordinates, 11);
        this.ready = true;
    },
};
</script>

<style lang="scss" scoped>
.leaflet-container {
    width: 100%;
    height: 300px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/AirportMap.vue